
import LocomotiveScroll from 'locomotive-scroll'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { Nav } from './components/nav'
import { Testimonials } from './components/testimonials'
import { SalonScroll } from './components/salon-scroll'
import { PrestationsAccordion } from './components/prestations-accordion'
import { PrestationsProduits } from './components/prestations-produits'
import { TarifsScroll } from './components/tarifs-scroll'
import { Blog } from './components/blog'

// import { PopUp } from './components/popup'
// import { DropDown } from './components/dropdown'

gsap.registerPlugin(ScrollTrigger);

class App {
  constructor() {

    // Locomotive Scroll v5 + GSAP ScrollTrigger sync
    const locomotiveScroll = new LocomotiveScroll({
      initCustomTicker: (render) => {
        gsap.ticker.add(render);
      },
      destroyCustomTicker: (render) => {
        gsap.ticker.remove(render);
      },
      scrollCallback: () => {
        ScrollTrigger.update();
      },
    });

    gsap.ticker.lagSmoothing(0);

    const nav = new Nav;

    if(document.querySelector('.home-testimonials')) {
      const testimonials = new Testimonials;
    }

    if(document.querySelector('.salon-frise')) {
      const salonScroll = new SalonScroll;
    }

    if(document.querySelector('.prestations-list__accordion')) {
      const prestationsAccordion = new PrestationsAccordion;
    }

    if(document.querySelector('.prestations-produits')) {
      const prestationsProduits = new PrestationsProduits;
    }

    if(document.querySelector('.tarifs-hero')) {
      const tarifsScroll = new TarifsScroll;
    }

    if(document.querySelector('.blog-articles')) {
      const blog = new Blog;
    }

    // if(document.querySelector('.dropdown')) {
    //   const dropdown = new DropDown;
    // }
    // if(document.querySelector('.popup')) {
    //   const popup = new PopUp;
    // }
  }
}

window.onload = function() {
  let app = new App();
};
